require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import draggable from "vuedraggable";
import { removeDemo, getUserList } from "../api/item-list";
import { setSessionItem, getSessionItem, ishasAgentId } from "@/basa/utils";
export default {
  name: "singleTableTabPage-tab-item-list-all",
  inject: ["reload"],
  components: {
    draggable
  },
  data() {
    return {
      isActive: 0,
      focuses: [{ focus: "all" }, { focus: "opened" }, { focus: "closed" }],
      // 表格数据
      tableData: [],
      // 表格命名
      tableName: this.tableList.featuresFeaturesItemListAll,
      // 表格数据
      tableThead: [],
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: 39,
          checked: true,
          fixed: true,
          type: "index"
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "名称",
          prop: "demoName",
          width: "auto",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "用户名",
          prop: "userName",
          width: "auto",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "性别",
          prop: "sex",
          width: "auto",
          checked: true,
          fixed: false,
          sortable: "custom",
          formatterName: "sexHandler"
        },
        {
          label: "爱好",
          prop: "hobby",
          width: "auto",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "年龄",
          prop: "age",
          width: "60",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "手机",
          prop: "phone",
          width: "100",
          checked: true,
          fixed: false,
          sortable: false,
          formatterName: "userMobileHandle"
        },
        {
          label: "出生日期",
          prop: "birthday",
          width: "120",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "单价",
          prop: "skuPrince",
          width: "60",
          align: "right",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "库存量",
          prop: "skuNum",
          width: "auto",
          align: "left",
          checked: true,
          fixed: false,
          sortable: false
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          checked: true,
          fixed: false,
          sortable: false,
          formatterName: "statusHandler"
        }
        // {
        //   label: "创建日期",
        //   prop: "createDate",
        //   width: "100",
        //   checked: true,
        //   fixed: false,
        //   sortable: false
        // },
        // {
        //   label: "修改日期",
        //   prop: "updateTime",
        //   width: "88",
        //   checked: true,
        //   fixed: false,
        //   sortable: false
        // },
        // {
        //   label: "修改人ID",
        //   prop: "updateUserId",
        //   width: "100",
        //   checked: true,
        //   fixed: false,
        //   sortable: false
        // }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,

      // 高级搜索数据 start
      // 高级搜索提交数据
      formData: {
        userName: "",
        demoName: "",
        phone: "",
        birthdayDate: ""
      },
      formDataSearch: "",
      value1: "",
      value2: "",
      value3: "",
      isShowSearch: true,
      value: "",
      totalNum: null,
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 分页
      pageNoCode: 1,
      pageSizeCode: this.getLocalPageSize(),
      // 全选，多选选择
      isIndeterminate: false,
      checkAll: false,
      // 删除
      delDemoId: "",
      typeDel: "",
      isSelection: false,
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 筛选字段调用函数集合
      filterMethodList: {
        filterHandler: (value, row, column) => {
          const property = column["property"];
          return row[property] === value;
        }
      },
      // 表格数据处理
      formatterList: {
        sexHandler(row, col) {
          switch (row.sex) {
            case "0":
              return "保密";
            case "1":
              return "男";
            case "2":
              return "女";
          }
        },
        statusHandler(row, col) {
          switch (row.status) {
            case 0:
              return "禁用";
            case 1:
              return "启用";
          }
        },
        userMobileHandle(row) {
          var reg = /(\d{3})\d{4}(\d{4})/;
          return row.phone
            ? (row.phone = row.phone.replace(reg, "$1****$2"))
            : (row.phone = "");
        }
      }
    };
  },
  mounted() {
    this.setInitData();
  },
  watch: {
    selectData(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item));
        });
      }
    }
  },
  methods: {
    setInitData() {
      this.setBreadcrumb();
      // this.getUserList();
      this.setTableWidth();
      this.renderTable();
    },
    // note 跟踪面包屑
    setBreadcrumb() {
      this.$store.dispatch("setBreadcrumb", [
        {
          level: "level2",
          data: {
            name: "功能模板2",
            path: "/singleTableTabPage/tab/item-list-all"
          }
        },
        {
          level: "level3",
          data: {
            name: "全部",
            path: "/singleTableTabPage/tab/item-list-all"
          }
        }
      ]);
    },
    // 导出
    async handleExport(type) {
      let sexObj = {
        0: "保密",
        1: "男",
        2: "女"
      };
      let statusobj = {
        0: "禁用",
        1: "启用"
      };
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("第一页");
      const page1Row1 = ws1.addRow([
        "序号",
        "名称",
        "用户名",
        "性别",
        "爱好",
        "年龄",
        "手机",
        "出生日期",
        "单价",
        "库存量",
        "状态"
      ]);
      if (type === "all") {
        let res = await getUserList({
          pageNo: 1,
          userName: "",
          pageSize: 5000,
          sortprop: "",
          sortord: "",
          isDelete: 0,
          loadingMessage: "加载中..."
        });

        if (res.data.data.rows.length > 0) {
          res.data.data.rows.forEach((item, index) => {
            ws1.addRow([
              index + 1,
              item.demoName,
              item.userName,
              sexObj[item.sex],
              item.hobby,
              item.age,
              item.phone
                ? item.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
                : "",
              item.birthday ? item.birthday.substr(0, 10) : "",
              item.skuPrince,
              item.skuNum,
              statusobj[item.status]
            ]);
          });
        }
      } else {
        this.tableData.forEach((item, index) => {
          ws1.addRow([
            index + 1,
            item.demoName,
            item.userName,
            sexObj[item.sex],
            item.hobby,
            item.age,
            item.phone
              ? item.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              : "",
            item.birthday ? item.birthday.substr(0, 10) : "",
            item.skuPrince,
            item.skuNum,
            statusobj[item.status]
          ]);
        });
      }
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "demoName", width: 20 },
        { key: "userName", width: 20 },
        { key: "sex", width: 6 },
        { key: "hobby", width: 18 },
        { key: "age", width: 10 },
        { key: "phone", width: 20 },
        { key: "birthday", width: 20 },
        { key: "skuPrince", width: 10 },
        { key: "skuNum", width: 15 },
        { key: "status", width: 10 }
      ];
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "功能模块.xlsx");
    },
    // popoverClose() {
    //   this.popoverShow = false;
    // },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    setStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, width, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    setTableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    setRowClass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    // 跳转编辑
    jumpEdit(index, row) {
      this.$router.push("/list-query/tab/edit-item/" + row.id);
    },
    // 跳转详情
    jumpDetail(index, row) {
      console.log(row);
      this.$router.push("/list-query/tab/item-detail/" + row.id);
    },
    // 跳转新增
    jumpNew() {
      this.$router.push("/list-query/tab/new-item");
    },
    // 删除数据
    handleDelete(index, row) {
      this.deleteLog();
      this.delDemoId = row.id;
      // this.delUser([row.demoId]);
    },
    // 删除弹框
    deleteLog() {
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          if (this.typeDel == "all") {
            this.delUser(this.idArrSelected);
          } else {
            this.delUser([this.delDemoId]);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    // 批量删除并刷新列表
    handleDelSelected() {
      if (this.idArrSelected) {
        this.typeDel = "all";
        this.deleteLog();
      } else {
        this.$message({
          message: "请选择您要删除的数据",
          type: "warning"
        });
      }
      // this.delUser(this.idArrSelected);
    },
    // 分页
    handlePrev() {},
    handleNext() {},
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
        setSessionItem("pageSize", this.tableName, val);
      }
      this.getUserList(this.formDataSearch);
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getUserList(this.formDataSearch);
    },
    // 默认条数
    getLocalPageSize() {
      return (
        getSessionItem(
          "pageSize",
          this.tableList.featuresFeaturesItemListAll
        ) || 20
      );
    },
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    searchItem(searchData) {
      console.log(searchData);
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.getUserList(this.formDataSearch);
    },
    selectDate(time) {
      this.formData.birthdayDate = time;
    },
    // 高级搜索 end
    // 数据请求
    getUserList(reqObj) {
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.sortprop = this.sortprop;
      obj.sortord = this.sortord;
      obj.pageNo = this.pageNoCode;
      obj.pageSize = this.pageSizeCode;
      obj.isDelete = 0;
      obj.status = this.status;
      obj.isShowPageLoading = true;
      getUserList(obj)
        .then(res => {
          this.isShowPagination = res.data.data.recordsTotal > 0;
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.pageNoCode = res.data.data.pageNo; // 当前页
          this.tableData.forEach((i, index) => {
            i.birthday = i.birthday ? i.birthday.substr(0, 10) : "";
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 删除请求
    delUser(arr) {
      removeDemo({
        demoIds: arr,
        isShowLoading: true,
        loadingMessage: "删除中,请稍等..."
      })
        .then(res => {
          this.$message({
            message: "删除成功",
            type: "success",
            // duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.$refs.multipleTable.tableData.length <= 1 && --this.pageNoCode;
          this.getUserList();
          this.isSelection = false;
        })
        .catch(e => {
          this.$message({
            showClose: true,
            message: "删除失败",
            type: "error",
            ccuiCustom: true
          });
        });
    },
    // 全选，多选选中
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true;
      } else if (val.length === 2) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    // 全选，多选选中 end
    // showPopoverPanel() {
    //   this.popoverShow = !this.popoverShow;
    // },
    // 排序
    changeSort(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getUserList();
    },
    // 页签跳转
    changeTab(data, index) {
      this.$router.push({ name: `singleTableTabPage-tab-item-list-${data}` });
    },
    resetTableColumn() {
      localStorage.removeItem(this.tableName);
      this.reload();
    }
  },
  beforeRouteLeave(to, from, next) {
    for (var key in this.$vnode.parent.parent.componentInstance.cache) {
      delete this.$vnode.parent.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  },
  activated() {
    this.getUserList(this.formDataSearch);
  }
};
